import React, { FC } from 'react';
import useSpotifyAuth from '../../../hooks/useSpotifyAuth';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import HeaderOne from '../HeaderOne';
import View from '../../../components/styled/View';
import LinearGradientButton from '../LinearGradientButton';
import ContainedButton from '../ContainedButton';
import styles from './styles';
import * as WebBrowser from 'expo-web-browser';
import {
  ACCOUNT_BODY,
  ACCOUNT_TITLE,
  ALREADY_A_MEMBER,
  AUTH_TITLE,
  BUTTON_TEXT,
  GEN_AUTH_BODY_TEXT,
  GEN_AUTH_BUTTON_TEXT,
  INITIALIZATION_BODY_TEXT,
  INITIALIZATION_TITLE,
  PLAYER_AUTH_BODY_TEXT,
  SECONDARY_BUTTON_TEXT,
  SPOTIFY_BUTTON_TEXT,
  SWAPPED_TITLE,
  SWAPPED_BODY_TEXT,
} from './constants';

// Has to exist in the location where the spotify pop up login screen gets called in order to close it on success
WebBrowser.maybeCompleteAuthSession();

export enum SpotifyErrorCodes {
  ACCOUNT_ERROR = 'ACCOUNT_ERROR',
  GENERAL_AUTHENTICATION = 'GENERAL_AUTHENTICATION',
  PLAYER_AUTHENTICATION = 'PLAYER_AUTHENTICATION',
  NONE = 'NONE',
  INITIALIZATION = 'INITIALIZATION',
  SWAPPED_DEVICE = 'SWAPPED_DEVICE',
}

export type SpotifyPlayerErrorProps = {
  errorType: keyof typeof SpotifyErrorCodes;
  handleSpotifyErrorReset: () => void;
};

export const SpotifyPlayerError: FC<SpotifyPlayerErrorProps> = (props) => {
  const { authenticateAsync } = useSpotifyAuth();

  const { errorType, handleSpotifyErrorReset } = props;

  const onButtonPress = () => {
    handleSpotifyErrorReset && handleSpotifyErrorReset();
  };

  const onReconnectSpotifyPress = async () => {
    await authenticateAsync();
    handleSpotifyErrorReset && handleSpotifyErrorReset();
  };

  const openSpotifyPremium = async () => {
    await WebBrowser.openBrowserAsync('https://www.spotify.com/us/premium/');
  };
  const data = {
    ACCOUNT_ERROR: {
      title: ACCOUNT_TITLE,
      bodyText: ACCOUNT_BODY,
      button: LinearGradientButton,
      buttonText: SPOTIFY_BUTTON_TEXT,
      onPress: openSpotifyPremium,
    },
    PLAYER_AUTHENTICATION: {
      title: AUTH_TITLE,
      bodyText: PLAYER_AUTH_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: BUTTON_TEXT,
      onPress: onButtonPress,
    },
    GENERAL_AUTHENTICATION: {
      title: AUTH_TITLE,
      bodyText: GEN_AUTH_BODY_TEXT,
      button: ContainedButton,
      buttonStyle: styles.connectButton,
      buttonText: GEN_AUTH_BUTTON_TEXT,
      onPress: onButtonPress,
    },
    INITIALIZATION: {
      title: INITIALIZATION_TITLE,
      bodyText: INITIALIZATION_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: BUTTON_TEXT,
      onPress: onButtonPress,
    },
    // NOT USED AT THE MOMENT
    SWAPPED_DEVICE: {
      title: SWAPPED_TITLE,
      bodyText: SWAPPED_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: BUTTON_TEXT,
      onPress: onButtonPress,
    },
  };
  const {
    bodyText = '',
    title,
    button: Button,
    buttonStyle = {},
    buttonText,
    onPress,
  } = data[errorType] || {};

  const displayAdditionalInfoForAccountError = () => {
    if (errorType === 'ACCOUNT_ERROR') {
      return (
        <View style={styles.moreAccountError}>
          <GalanoGrotesqueText style={styles.platformText}>
            {ALREADY_A_MEMBER}
          </GalanoGrotesqueText>
          <ContainedButton
            style={styles.connectButton}
            title={SECONDARY_BUTTON_TEXT}
            onPress={onReconnectSpotifyPress}
          />
        </View>
      );
    }
    return null;
  };

  return (
    <View style={styles.container}>
      <HeaderOne style={styles.header} title={title} />
      <GalanoGrotesqueText style={styles.platformText}>
        {bodyText}
      </GalanoGrotesqueText>
      <Button style={buttonStyle} title={buttonText} onPress={onPress} />
      {displayAdditionalInfoForAccountError()}
    </View>
  );
};

export default SpotifyPlayerError;
